// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab4627c6","453":"b199cb39","667":"ea4c7d3a"}[chunkId] + ".chunk.js";
};